<template>
  <div>
    <el-dialog
      title="审核拒绝"
      :visible="isShowRefuseDialog"
      width="30%"
      @open="init"
      @close="handleDialog"
      :close-on-click-modal="false"
    >
      <div>
        <div style="font-size: 16px; display: flex">
          <i
            class="el-icon-info"
            style="color: #e6a23c; font-size: 22px; margin-right: 6px"
          ></i
          >确定审核拒绝？
        </div>
        <p>
          <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label=" " prop="approveRemark">
              <el-input
                type="textarea"
                placeholder="请输入拒绝原因"
                v-model="form.approveRemark"
                style="width: 90%"
              ></el-input>
            </el-form-item>
          </el-form>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    isShowRefuseDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        orderId: '',
        status: '02',
        approveRemark: '',
      },
      rules: {
        approveRemark: [
          { required: true, message: '请输入拒绝原因', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    init() {
      this.form.orderId = this.id
    },
    handleDialog() {
      this.$refs['form'].resetFields()
      this.form = {
        orderId: '',
        status: '02',
        approveRemark: '',
      }
      this.$emit('update:isShowRefuseDialog', false)
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const params = {
            ...this.form,
          }
          this.$axios
            .post('/depositWithdraw/approveDepositWithdraw', params)
            .then(res => {
              if (res.code === 200) {
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })
                this.$emit('update:isShowRefuseDialog', false)
                this.$bus.$emit('refresh') //通知刷新
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
</style>